import React from 'react';

export class MEMS extends React.Component {
  render(){
      return (
        <div className="w3-card w3-animate-bottom full-project-card" id="clapsr">
          <h1>MEMS Fabrication</h1>
          <p>I spent a few years at Cornell working on MEMS fabrication at the Cornell Nanofabrication Facility (CNF). Spent a lot of time in the cleanroom over there.</p>
          <p>Was a great learning experience.</p>
          <p>Stay tuned for more information as I figure out what info I want to share to the world.</p>
        </div>
    );
  }
}
